import template from './location_zone.all.html';
import controller from './location_zone.all.controller';
import './location_zone.all.scss';

const locationZoneAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationZoneAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/all/location_zone.all.component.js